export const queryKey = 'user-notifications';
